module.exports = __webpack_public_path__ + "assets/dollar.945cedbb.svg";